<template>
  <section class="mb-5">
    <div class="vendors bg-grey rounded p-2 p-lg-4">
      <Carousel :circular="true" :numVisible="5" :numScroll="5" :responsiveOptions="responsiveOptions" :value="vendors">
        <template #item="slotProps">
          <div class="px-2 px-lg-4 flex-center h-100">
            <img class="w-100" :src="slotProps.data.logo" :alt="slotProps.data.name" />
          </div>
        </template>
      </Carousel>
    </div>

  </section>
</template>

<script>
  import Carousel from 'primevue/carousel';

  export default {
    components: {
      Carousel
    },
    data() {
      return {
        responsiveOptions: [
          {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 3
          },
          {
            breakpoint: '600px',
            numVisible: 2,
            numScroll: 2
          }
        ],
        vendors: null
      }
    },
    mounted() {
      this.getVendors()
    },
    methods: {
      getVendors() {
        axios.get(route('logindata')).then(elem => this.vendors = elem.data.manufacturers)
      }
    }
  }
</script>

<style>
  .p-carousel-indicators {
    display: none;
  }
</style>
